import React, { useContext, useEffect, useState } from 'react';
import { Button, Checkbox, Col, DatePicker, Flex, Form, Input, Row, Select, Tabs } from 'antd';
import { useLoaderData, useNavigate, useOutletContext, useParams } from 'react-router-dom';
import { Badge } from 'flowbite-react';
import dayjs from 'dayjs';
import EventEmitter from '../../utils/eventEmitter';
import { detailedOperationColumns, operationColumns } from '../../inventoryServices/utils/TableColumns';
import DetailedOperationModal from '../../inventoryServices/modals/DetailedOperationModal';
import StatusComponent from '../../globalComponents/StatusComponent';
import usePurchaseOrderAPI from '../apis/purchaseOrdersAPI';
import GoBack from '../../globalComponents/GoBack';
import EditableTable from '../../globalComponents/EditableTable';
import { confirmQuantities } from '../utils/alertUtils';
import { STREAM_URL } from '../utils/axios';
import AuthContext from '../../utils/AuthContext';



const shippingPolicies = [
  {value: '', label: ''},
  {value: 'asap', label: 'As soon as possible'},
  {value: 'all_at_once', label: 'When all product are ready'}
]


const PurchaseOrderTransferChanges = () => {
  const [form] = Form.useForm();
  const { success, error } = useOutletContext();
  const { user } = useContext(AuthContext);
  const { transfer, products, locations, operationTypes, contacts } = useLoaderData();
  // console.log(transfer)
  transfer['scheduled_date'] = transfer.scheduled_date ? dayjs(transfer['scheduled_date'], 'YYYY-MM-DD HH:mm') : '';
  transfer['effective_date'] = transfer.effective_date ? dayjs(transfer['effective_date'], 'YYYY-MM-DD HH:mm') : '';
  const params = useParams();
  const navigate = useNavigate();
  const { create, update, validate } = usePurchaseOrderAPI();
  const [operations, setOperations] = useState(transfer.transfer_operations ? transfer.transfer_operations : []);
  const [detailedOperations, setDetailedOperations] = useState(transfer.operations ? transfer.operations : []);
  const [operation_type, setOperationType] = useState('');


  const onChangeOperation = option => {
    delete option.value;
    delete option.label;
    form.setFieldValue('source_location', option.source);
    form.setFieldValue('destination_location', option.destination);
    setOperationType(option.type);
    // console.log(option)
  };


  
  const handleSubmit = async() => {
    let data = form.getFieldsValue();
    data['operations'] = operations;
    data['detailed_operations'] = detailedOperations;
    data['source_location'] = form.getFieldValue('source_location');
    data['scheduled_date'] = new Date(data.scheduled_date).toISOString();
    data['effective_date'] = new Date(data.scheduled_date).toISOString();

    create(data, success);
    // console.log(data)
  }

  const handleUpdate = async() => {
    let data = form.getFieldsValue();
    // update(analytic.seo, data, success);
    // console.log(data)
  }

  // const validate = () => {
  //   let data = form.getFieldsValue();
  //   data['operations'] = operations;
  //   // data['detailed_operations'] = detailedOperations;
  //   data['source_location'] = form.getFieldValue('source_location');
  //   data['scheduled_date'] = new Date(data.scheduled_date).toISOString();
  //   data['effective_date'] = new Date(data.scheduled_date).toISOString();
  // }

  const updateTransfer = async (status) => {
    let data = form.getFieldsValue();
    data['status'] = status;
    data['operations'] = detailedOperations;
    // data['detailed_operations'] = detailedOperations;
    data['location_src_id'] = form.getFieldValue('location_src_id');
    data['location_dest_id'] = form.getFieldValue('location_dest_id');
    data['scheduled_date'] = new Date(data.scheduled_date).toISOString();
    data['effective_date'] = new Date(data.scheduled_date).toISOString();
    data['number'] = transfer.number;
    data['purchase_code'] = params.id;
    data.validated_by = user.id;
    let filtered = data.operations.filter(op => op.done_quantity > 0).length;
    if (filtered > 0) {
      validate(data, success);
    }else {
      confirmQuantities(validate, data, success, setQuantities);
    }
    
    // console.log(filtered)
  }

  detailedOperationColumns.forEach((col, idx) => {
    // if (detailedOperationColumns[idx].dataIndex.includes('reserved')) {
    //   delete detailedOperationColumns[idx];
    // };
    let disabledCols = ['product_id', 'location_src_id', 'location_dest_id', 'demand_quantity']
    if (transfer.generated) {
      if (disabledCols.includes(detailedOperationColumns[idx].dataIndex)) {
        detailedOperationColumns[idx].readOnly = true;
      }
    }
  });

  useEffect(() => {
    const es = new EventSource(STREAM_URL+"purchase-orders/stream/product/validated");
    es.addEventListener('open', (event) => {
      console.log("Open SSE connection.");
    });

    es.addEventListener("message", (event) => { 
      if (event) {
        const data = JSON.parse(event.data);
        if (data.message === 'received') {
          navigate(`/purchase/purchase-orders/${params.id}/transfers/${params.action}`);
          return;
        } 
      }
    });
    
    es.addEventListener("error", (event) => {
      if (event.type === "error") {
        console.error("Connection error:", event.message);
      } else if (event.type === "exception") {
        console.error("Error:", event.message, event.error);
      }
    });
    
    es.addEventListener("close", (event) => {
      console.log("Close SSE connection.");
    });
    return () => {
      es.close();
    }
  },[])

  const addLine = () => { 
    let array = [...detailedOperations];
    let obj = {
      key: detailedOperations.length,
      product_id: '',
      location_src_id: form.getFieldValue('location_src_id'),
      location_dest_id: form.getFieldValue('location_dest_id'),
      // source_package: ' ',
      // destination_package: ' ',
      lot_serial_number_id: ' ',
      done_quantity: 0,
      reserved_quantity: 0,
      demand_quantity: 0,
      description: '',
      packaging_id: '',
    };
    array.push(obj);
    setDetailedOperations(array);
    
  };

  const addOperationLine = () => {
    let array = [...operations];
    let obj = {
      key: operations.length,
      product_id: '',
      description: '',
      packaging_id: '',
      demand_quantity: 0,
      reserved_quantity: 0,
      done_quantity: 0,
    };
    array.push(obj);
    setOperations(array);
  }

  const setQuantities = () => {
    let operations_ = [...detailedOperations];
    operations_.forEach((product, idx) => {
      operations_[idx]['done_quantity'] = operations_[idx].demand_quantity;
    });
    setDetailedOperations(operations_);
  }

  const clearQuantities = () => {
    let operations_ = [...detailedOperations];
    operations_.forEach((product, idx) => {
      operations_[idx]['done_quantity'] = operations_[idx].demand_quantity;
    });
    setDetailedOperations(operations_);
  }
  

  return (
    <div className='container mx-auto' style={{maxWidth: '1200px'}}>
      <div>
        <div className='flex'>
          <div className='mb-3'><GoBack /></div>
        </div>
        {transfer.number && 
        <div className='flex justify-between bg-white'>
          <Flex wrap='wrap' align='center' gap={'small'} className='ps-1' style={{maxWidth: '70%'}}>
            {/* <Button size='small' onClick={handleUpdate} type='text' style={{height: '100%'}}>UPDATE</Button> */}
            {transfer.status === 'draft' && <Button size='small' type='primary' className='font-semibold bg-[#189aa0] hover-btn' onClick={()=> updateTransfer('waiting')}>MARK AS TODO</Button>}
              {(transfer.status === 'ready' || transfer.status === 'waiting') && 
                <>
                <Button size='small' type='primary' className='font-semibold bg-[#189aa0] hover-btn' onClick={()=> updateTransfer('done')}>VALIDATE</Button>
                <Button size='small' type='text' className='font-semibold text-[#189aa0]' onClick={setQuantities}>SET QUANTITIES</Button>
                <Button size='small' type='text' className='font-semibold text-[#189aa0]'>PRINT</Button>
                {/* <Button size='small' type='text' className='font-semibold text-[#189aa0]'>UNRESERVE</Button> */}
                <Button size='small' type='text' className='font-semibold text-[#189aa0]'>UNLOCK</Button>
                </>
              }
            <Button size='small' type='text' className='font-semibold text-[#189aa0]'>PRINT LABELS</Button>
            <Button size='small' type='text' className='font-semibold text-[#189aa0]'>SCRAP</Button>
            <Button size='small' type='text' className='font-semibold text-[#189aa0]'>CANCEL</Button>
          </Flex>
          <StatusComponent formValue={transfer} name={'TRANSFERS'}/>
        </div>
        }
        
      </div>
      <div className='mt-5 bg-white p-3 shadow'>
        <Form 
          form={form}
          labelAlign='left'
          labelCol={{span: 9}}
          initialValues={transfer.number ? transfer :
            {pick_later: false, shipping_policy: 'asap'}
          }
          variant='borderless'
        >
          {/* <Badge className="text-slate-500 text-md bg-transparent	border-b-2">Simulatneous Conditions To Met</Badge> */}
          <Row>
            <Col md={{span: 11}}>
              <Form.Item label={'Contact'} name={'contact_id'} className='font-bold mb-1' required>
                <Select options={contacts.map(contact => ({value: contact.id, label: contact.name}))} className='font-normal' />
              </Form.Item>
              <Form.Item label='Operation Type' name={'operation_type_id'} className='font-bold mb-1' required>
                <Select options={operationTypes.map(operation => ({value: operation.id, label: operation.name, type: operation.type, destination: operation.destination_location, source: operation.source_location}))} onChange={(v, option) => onChangeOperation(option)} className='font-normal' />
              </Form.Item>
              {(operation_type === 'delivery' || operation_type === 'internal_transfer') && <Form.Item label='Source Location' name={'source_location'} className='font-bold mb-1' required>
                <Select options={locations.map(location => ({value: location.id, label: `${location.name}`}))} className='font-normal' />
              </Form.Item>}
              {(operation_type === 'receipt' || operation_type === 'internal_transfer') && <Form.Item label='Destination Location' name={'destination_location'} className='font-bold mb-1' required>
                <Select options={locations.map(location => ({value: location.id, label: `${location.name}`}))}  className='font-normal' />
              </Form.Item>}
              {operation_type !== 'delivery' &&<Form.Item label='Validated By' className='font-bold mb-1' required>
                <Input type='text' value={user.user} readOnly className='font-normal input-outline-none' />
              </Form.Item>}
            </Col>
            <Col md={{span: 11, offset: 1}}>
              <Form.Item label='Scheduled Date' name={'scheduled_date'} className='font-bold mb-1' required>
                <DatePicker showTime format={'YYYY-MM-DD HH:mm'} className='font-normal'/>
              </Form.Item>
              <Form.Item label='Effective Date' name={'effective_date'} className='font-bold mb-1' required>
                <DatePicker showTime format={'YYYY-MM-DD HH:mm'} className='font-normal'/>
              </Form.Item>
              <Form.Item label='Source Document' name={'source_document'} className='font-bold mb-1' required>
                <Input className='border-x-0 border-t-0 w-full text-gray-800 input-outline-none font-normal' />
              </Form.Item>
              <Form.Item label='Pick Later' name={'is_pick_later'} className='font-bold mb-1' valuePropName='checked' required>
                <Checkbox />
              </Form.Item>
            </Col>
          </Row>
          <Tabs 
            type='card'
            items={[
              {
                key: 1,
                label: 'Detailed Operations',
                children: 
                <EditableTable
                  option1={locations}
                  dataSource={detailedOperations}
                  setDataSource={setDetailedOperations}
                  addLine={addLine}
                  columns={detailedOperationColumns}
                  dependant={true}
                  products={products}
                />
              },
              {
                key: '2',
                label: 'Operations',
                children: 
                <EditableTable
                  name={'transfer'}
                  dataSource={detailedOperations}
                  setDataSource={setDetailedOperations}
                  addLine={addOperationLine}
                  columns={operationColumns}
                  products={products}
                />
              },
              {
                key: '3',
                label: 'Additional Info',
                forceRender: true,
                children: 
                  <Row>
                    <Col md={{span: 11}}>
                      <Badge className="text-slate-500 text-sm bg-transparent	border-b-2 mb-3">SHIPPING INFORMATION</Badge> 
                      <Form.Item label='Carrier' name={'carrier'} className='font-bold mb-1' required>
                        <Select options={[]} className='font-normal' />
                      </Form.Item>
                      <Form.Item label='Tracking Reference' name={'tracking_reference'} className='font-bold mb-1' required>
                        <Input className='input-outline-none font-normal' />
                      </Form.Item>
                      {/* <Form.Item label='Carrier' name={'carrier'} className='font-bold mb-1' required>
                        <Select options={[]} className='font-normal' />
                      </Form.Item> */}
                    </Col>
                    <Col md={{span: 11, offset: 1}}>
                      <Badge className="text-slate-500 text-sm bg-transparent	border-b-2 mb-3">OTHER INFORMATION</Badge> 
                      <Form.Item label='Shipping Policy' name={'shipping_policy'} className='font-bold mb-1' required>
                        <Select options={shippingPolicies} className='font-normal' />
                      </Form.Item>
                      <Form.Item label='Responsible' name={'user_id'} className='font-bold mb-1' required>
                        <Select options={[]} className='font-normal' />
                      </Form.Item>
                      <Form.Item label='Outlet' name={'outlet_id'} className='font-bold mb-1' required>
                        <Select options={[]} className='font-normal' />
                      </Form.Item>
                    </Col>
                  </Row>
              },
              {
                key: '4',
                label: 'Note',
                forceRender: true,
                children: 
                <Form.Item name={'note'} className='font-bold mb-1' required>
                  <Input className='input-outline-none font-normal' placeholder='Add an internal note that will be printed at the Picking Operations sheets' />
                </Form.Item>
              }
            ]}
          />          
        </Form>
      </div>
      <DetailedOperationModal />
    </div>
  )
}
export default PurchaseOrderTransferChanges;